import React, { useEffect, useState } from "react";
import lakersLogo from "../../assets/images/live-lakers-logo.png";
import bullsLogo from "../../assets/images/live-bulls-logo.png";

const TOTAL = 15;

const LiveSimulatedGame = () => {
    const [currentQuarter, setCurrentQuarter] = useState(2);
    const [remaining, setRemaining] = useState(7);

    useEffect(() => {
        const timer = setInterval(() => {
            setRemaining((value) => {
                if (value > 0) return value - 1;

                setCurrentQuarter((quarter) => {
                    if (quarter < 4) return quarter + 1;
                    clearInterval(timer);
                    return quarter;
                });

                return TOTAL;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const progress = Math.max(
        0,
        Math.min(100, ((TOTAL - remaining) / TOTAL) * 100)
    );

    return (
        
        <article className="game-card card exact-live-game">
            <div className="live-game-header">
                <div className="live-game-title">LIVE SIMULATED GAME</div>
                <span className="live-badge">LIVE</span>
            </div>

            <div className="live-scoreband">
                <div className="live-team live-team-left">
                    <img src={lakersLogo} alt="Los Angeles Lakers" />
                    <div className="live-team-copy">
                        <small>LOS ANGELES</small>
                        <strong>LAKERS</strong>
                        <em>2000</em>
                    </div>
                </div>

                <div className="live-score">14</div>

                <div className="live-clock">
                    <small>QUARTER <span>{currentQuarter}</span></small>
                    <strong>00:{String(remaining).padStart(2, "0")}</strong>
                </div>

                <div className="live-score">10</div>

                <div className="live-team live-team-right">
                    <div className="live-team-copy">
                        <small>CHICAGO</small>
                        <strong>BULLS</strong>
                        <em>1996</em>
                    </div>
                    <img src={bullsLogo} alt="Chicago Bulls" />
                </div>
            </div>

            <div className="live-last-play">
                <strong>LAST PLAY</strong>
                <div className="live-last-row">
                    <p>Kobe Bryant drives to the lane... kicks to Shaq... dunk! Lakers take the lead!</p>
                    <time>00:05</time>
                </div>
            </div>

            <div className="quarter-loader" aria-label="Game quarter progress">
                {[1, 2, 3, 4].map((quarter) => {
                    const complete = quarter < currentQuarter;
                    const active = quarter === currentQuarter;
                    const upcoming = quarter > currentQuarter;

                    return (
                        <div
                            key={quarter}
                            className={`quarter-item ${complete ? "complete" : active ? "active" : "upcoming"} ${quarter === 4 ? "last" : ""}`}
                            data-quarter={quarter}
                        >
                            {quarter === 1 && <span className="q-label">Q1</span>}

                            <span className="q-dot">
                                {(complete || active) && <span className="tick">✓</span>}
                            </span>

                            {quarter !== 1 && <span className="q-label">Q{quarter}</span>}

                            <span className={`q-line ${upcoming ? "dotted" : ""}`}>
                                {(complete || active) && (
                                    <span
                                        className="q-line-fill"
                                        style={{ width: complete ? "100%" : `${progress}%` }}
                                    />
                                )}
                            </span>
                        </div>
                    );
                })}
            </div>
        </article>
    );
};

export default LiveSimulatedGame;
